export default __webpack_public_path__ + "static/media/li.63dd6c38.jpg";